import { buildAxiosErrorMessage } from '@/utils/buildAxiosErrorMessage'
import * as Sentry from '@sentry/react'
import axios from 'axios'
import { setupAuthInterceptor } from './axios.interceptors'

export const axiosBender = axios.create({
  timeout: 20000,
  baseURL: import.meta.env.VITE_URL_BENDER_API,
  headers: {
    accept: 'application/json',
    'Content-Type': 'application/json'
  }
})

// Setup auth interceptor
setupAuthInterceptor(axiosBender)

// Error handling interceptor
axiosBender.interceptors.response.use(undefined, error => {
  const errorMessage = buildAxiosErrorMessage(error, 'Bender Error')
  console.error(errorMessage)
  Sentry.captureException(errorMessage)
})
